<template>
  <v-container class='intro-section step' >
    <v-row justify="center" class="full-height" >
      <v-col cols='12' class="intro-col" data-aos="zoom-in">
        <div  class="intro-txt" ref="typedElement">
          <p
          data-aos='fade-down'
          data-aos-delay="750"
          data-aos-duration="2000"
          data-aos-mirror="true"
          data-aos-once="false"
          >
            {{$t('_intro_txt_1')}}
           </p>
           <br>
           <p data-aos='fade-down'
          data-aos-delay="1000"
          data-aos-duration="2000"
          data-aos-mirror="true"
          data-aos-once="false"
           >
            {{$t('_intro_txt_2')}}
           </p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
  beforeUnmount () {
  }
}
</script>

<style scoped>
.step {
  height: 100vh!important;
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-snap-align: start;
}
  .intro-section {
    font-family: "ZenKakuRegular", sans-serif;
  }
  .intro-col {
    background-image: url('@/assets/image/pic1.png');
    background-repeat: no-repeat, repeat;
    background-size: contain;
    padding: 50px 205px!important;
    height: fit-content;
    min-height: 400px!important;
    background-position: center;
    margin: auto;

  }
  .intro-txt {
    text-align: center;
    line-height: 2!important;
    font-weight: 600;
  }
  .intro-col p {
    white-space: pre-line;
  }
  @media (max-width: 1200px) {
    /* .intro-col {
      padding: 50px 90px!important;
    } */
  }
  @media (max-width: 960px) {
    .step {
      height: unset!important;
      scroll-snap-align:unset;
      margin-top: 20%;
    }
    .intro-col {
      padding: 50px 10px!important;
      background-size: cover;
      margin: unset!important;
    }
    .full-height {
      height: unset!important;
    }
  }
  @media (max-width: 600px) {
    .intro-txt {
      text-align: left;
    }
  }
</style>